import { CSSObject, ButtonProps as MantineButtonProps, MantineTheme } from "@mantine/core";
import { colors } from "theme";

export type ButtonType = "primary" | "secondary" | "link";

export const mantineVariantsMap: Record<ButtonType, MantineButtonProps<"button">["variant"]> = {
  primary: "filled",
  secondary: "outline",
  link: "subtle",
} as const;

export const getTypeVariants = (theme: MantineTheme): Record<ButtonType, CSSObject> =>
  ({
    primary: {
      color: colors.white,
      backgroundColor: theme.other.primary[60],

      "&:not(:disabled):active": {
        boxShadow: "inset 0px 2px 0px rgba(11, 31, 44, 0.5)",
        transform: "none",
      },

      "&:hover": {
        backgroundColor: theme.other.primary[60],
      },

      "&:not(.__mantine-ref-loading):disabled": {
        backgroundColor: colors.grey[3],
        border: `1px solid ${colors.borderBlack}`,
        color: colors.grey[50],
        boxShadow: "0px 1px 0px rgba(11, 31, 44, 0.16)",
      },
    },
    secondary: {
      color: theme.other.primary[60],
      backgroundColor: colors.white,
      border: `1px solid ${colors.grey[50]}`,
      boxShadow: "0px 1px 0px rgba(11, 31, 44, 0.1)",

      "&:not(:disabled):active": {
        transform: "none",
      },

      "&:not(.__mantine-ref-loading):disabled": {
        backgroundColor: colors.grey[3],
        border: `1px solid ${colors.grey[50]}`,
        color: colors.grey[50],
        boxShadow: "0px 1px 0px rgba(11, 31, 44, 0.1)",
      },
    },
    link: {
      color: theme.other.primary[60],
      padding: 0,
      margin: 0,
      fontWeight: 400,
      textDecoration: "underline",
      "div > span": {
        whiteSpace: "normal",
        wordWrap: "break-word",
      },

      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  } as const);
